import ApplicationController from './application_controller';

const SELECTIZE_BIND_ATTEMPTS = 50;

/**
 * On the new prepayment form, hides Payment type when "Invoiced to" is an insurance plan. A
 * prepayment from a plan is that payer's deposit and is always recorded as an insurance payment
 * (PatientInvoicesController#create_prepayment), so the field would only mislead. The type is
 * reset to Cash first so a Credit card pick cannot leave a card charge notice behind.
 *
 * Values:
 *   insuranceIds - ids of the patient payment methods in the select that are insurance plans
 */
export default class extends ApplicationController {
  static targets = ['methodSelect', 'typeSelect', 'typeField', 'insuranceNotice'];

  static values = { insuranceIds: Array };

  connect() {
    this.selectizeHandlers = [];
    this.bindSelectize(this.methodSelectTarget);
    this.refresh();
  }

  disconnect() {
    this.selectizeHandlers.forEach(({ selectize, handler }) => selectize.off('change', handler));
    this.selectizeHandlers = [];
  }

  /**
   * Selectize replaces the native select and only emits jQuery events, so a Stimulus `change->`
   * action never hears a pick. Bind to the widget once it exists (it initialises on turbo:load).
   */
  bindSelectize(select, attempt = 0) {
    if (!this.element.isConnected) return;
    if (!select.selectize) {
      if (attempt < SELECTIZE_BIND_ATTEMPTS) {
        setTimeout(() => this.bindSelectize(select, attempt + 1), 100);
      }
      return;
    }
    const handler = () => this.refresh();
    select.selectize.on('change', handler);
    this.selectizeHandlers.push({ selectize: select.selectize, handler });
  }

  refresh() {
    const insurance = this.insuranceIdsValue.includes(this.methodSelectTarget.value);
    if (insurance && this.typeSelectTarget.value !== 'cash') this.setType('cash');
    this.typeFieldTarget.hidden = insurance;
    if (this.hasInsuranceNoticeTarget) this.insuranceNoticeTarget.hidden = !insurance;
  }

  setType(value) {
    const { selectize } = this.typeSelectTarget;
    if (selectize) {
      selectize.setValue(value);
    } else {
      this.typeSelectTarget.value = value;
      this.typeSelectTarget.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}
